
// script for footer menu toggle for mobile

document.addEventListener("DOMContentLoaded", function () {
  const footers = document.querySelectorAll(".cstm-foot-menu-main");

  footers.forEach((footer) => {
    const heading = footer.querySelector(".footer-block__heading");
    const menu = footer.querySelector(".cstm-foot-menu-detail");

    heading.style.cursor = "pointer";

    heading.addEventListener("click", () => {
      const isCurrentlyActive = menu.classList.contains("active");

      // Close all menus first
      footers.forEach((otherFooter) => {
        const otherMenu = otherFooter.querySelector(".cstm-foot-menu-detail");
        otherMenu.classList.remove("active");
        otherFooter.classList.remove("menu_active");
      });

      // If it wasn't active before, activate it
      if (!isCurrentlyActive) {
        menu.classList.add("active");
        footer.classList.add("menu_active");
      }
      // If it was active, we already removed it above (toggle-off)
    });
  });
});







// for the announcement bar 
document.addEventListener("DOMContentLoaded", function () {
    const announceContent = document.querySelector(".announceBarContentMob");
    const showBtn = document.querySelector(".show_btn");
    const hideBtn = document.querySelector(".announceHide");

    // // Initial state
    // announceContent.style.display = "none";

    // Show content
    showBtn.addEventListener("click", function () {
      announceContent.style.display = "block";
      showBtn.style.display = "none";
    });

    // Hide content
    hideBtn.addEventListener("click", function () {
      announceContent.style.display = "none";
      showBtn.style.display = "inline-block";
    });
  });

 // custom script to update side cart on addng product to cart from rebuy 
 document.addEventListener('rebuy:cart.add', (event) => {
        console.log('rebuy:cart.add event', event.detail);

              const rootUrl = Shopify?.routes?.root || '/';
        fetch(`${rootUrl}cart?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
                const cartDrawerElm = document.querySelector('cart-drawer');
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const newCartDrawerHTML = html.querySelector('#CartDrawer').innerHTML;
                cartDrawerElm.querySelector('#CartDrawer').innerHTML = newCartDrawerHTML;
                cartDrawerElm.classList.remove('is-empty');
                cartDrawerElm.open();
                
                document.getElementById("CartDrawer-Overlay").addEventListener("click", function(e) {
                    if (document.querySelector('cart-drawer')) {
                        document.querySelector('cart-drawer').classList.remove('active');
                    }

                    console.log('click', document.querySelector('body').classList)
                    document.querySelector('body').classList.remove('modal-open-cart', 'overflow-hidden');
                });

                document.querySelector(".drawer__close").addEventListener("click", function(e) {
                    if (document.querySelector('cart-drawer')) {
                        document.querySelector('cart-drawer').classList.remove('active');
                    }
                    document.querySelector('body').classList.remove('modal-open-cart', 'overflow-hidden');
                });
            });
      });


// CUSTOM COLLECTION PAGE DROPDOWN SELECTION AND PRICE CHANGE BOOST-APP
           document.addEventListener('change', function (e) {
        // Check if the changed element is a variant select box
        if (e.target.matches('.cstm_prod_variant_select')) {
          e.preventDefault();

          const selectEl = e.target;
          const selectedOption = selectEl.options[selectEl.selectedIndex];
          const selectedId = selectedOption.id;

            // ✅ Get data-price attribute from selected option
            const rawPrice = selectedOption.getAttribute('data-price');

            // ✅ Format price as "$xx.xx USD"
            let formattedPrice = '';
            if (rawPrice) {
            const priceNum = parseFloat(rawPrice); // Assuming cents
            formattedPrice = `$${priceNum} USD`;
            }

                    // Find common wrapper (adjust selector if needed)
            const wrapper = selectEl.closest('.product-card, .boost-sd__product-item, .product-grid-item');

            if (wrapper) {
            const priceContainer = wrapper.querySelector('.boost-sd__product-price');

            if (priceContainer) {
                const priceDisplayDiv = priceContainer.querySelector('.boost-sd__format-currency');
                
                if (priceDisplayDiv) {
                priceDisplayDiv.textContent = formattedPrice;
                }
            }
            }

          // Get the button in the same container
          const container = selectEl.closest('.cstm_add_Cart');
          const button = container.querySelector('.cstm_btn');

          // Build new metadata object
          const metadata = {
            action: {
              addToCart: {
                productId: selectedId,
                selling_plan: ""
              }
            }
          };

          const jsonStr = JSON.stringify(metadata);
          button.setAttribute('data-metadata', jsonStr);

          console.log('Set new metadata:', jsonStr);
        }
      });


// slick slider home top
 $('.cstm-feat-coll-slider').slick({
         infinite: true,
        autoplay: true,
        arrows: true,
        slidesToShow: 4,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
              nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              arrows: true,
              dots: false,
              prevArrow: '<button class="slide-arrow prev-arrow"></button>',
              nextArrow: '<button class="slide-arrow next-arrow"></button>',
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 510,
            settings: {
              arrows: true,
              dots: false,
              prevArrow: '<button class="slide-arrow prev-arrow"></button>',
              nextArrow: '<button class="slide-arrow next-arrow"></button>',
              slidesToShow: 1
            }
          }
        ]
      });


     
















     
 



    document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("li.grid__item").forEach(li => {
    const select = li.querySelector(".cstm_prod_variant_select_card__product");
    const button = li.querySelector(".cstm_btn_card__product");

    if (!select || !button) return;

    // Update button when dropdown changes
    select.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption.value;
      const disabled = selectedOption.disabled;

      button.setAttribute("data-product-id", variantId);

      if (disabled) {
        button.disabled = true;
        button.textContent = "SOLD OUT";
      } else {
        button.disabled = false;
        button.textContent = "ADD TO CART";
      }
    });
  });

  // Handle add to cart on all buttons
  document.querySelectorAll(".cstm_btn_card__product").forEach(button => {
    button.addEventListener("click", () => {
      const productId = button.getAttribute("data-product-id");

      if (!productId) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(res => res.json())
      .then(data => {
        console.log("Added to cart:", data);

        // ✅ Optional: Show a mini-cart or confirmation
        alert("Product added to cart!");
      })
      .catch(err => {
        console.error("Error adding to cart:", err);
        alert("Sorry, could not add to cart.");
      });
    });
  });
});



















// document.querySelectorAll('header-menu, details-disclosure').forEach((wrapper) => {
//   const details = wrapper.querySelector('details');
//   const summary = details?.querySelector('summary');
//   const content = summary?.nextElementSibling;

//   if (!details || !summary) return;

//   const li = wrapper.closest('li');

//   // 👉 Add base class on li
//   if (li) {
//     li.classList.add('has-mega-menu');
//   }

//   let closeTimeout;

//   // Only apply hover on desktop
//   if (window.matchMedia('(hover: hover)').matches) {

//     wrapper.addEventListener('mouseenter', () => {
//       clearTimeout(closeTimeout);

//       details.setAttribute('open', true);
//       summary.setAttribute('aria-expanded', true);

//       // 👉 Add open class
//       if (li) li.classList.add('is-open');

//       // Play animations
//       if (content) {
//         const animations = content.getAnimations();
//         animations.forEach((animation) => animation.play());
//       }

//       // Header support
//       const header = document.querySelector('.header-wrapper');
//       if (header) {
//         header.preventHide = true;

//         if (
//           document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === ''
//         ) {
//           document.documentElement.style.setProperty(
//             '--header-bottom-position-desktop',
//             `${Math.floor(header.getBoundingClientRect().bottom)}px`
//           );
//         }
//       }
//     });

//     wrapper.addEventListener('mouseleave', () => {
//       closeTimeout = setTimeout(() => {
//         details.removeAttribute('open');
//         summary.setAttribute('aria-expanded', false);

//         // 👉 Remove open class
//         if (li) li.classList.remove('is-open');

//         if (content) {
//           const animations = content.getAnimations();
//           animations.forEach((animation) => animation.cancel());
//         }

//         const header = document.querySelector('.header-wrapper');
//         if (header) {
//           header.preventHide = false;
//         }

//       }, 10);
//     });
//   }
// });


/* 👉 Handle items WITHOUT mega menu */
document.querySelectorAll('.list-menu > li').forEach((li) => {
  if (!li.querySelector('header-menu') && !li.querySelector('details-disclosure')) {
    li.classList.add('no-mega-menu');
  }
});




document.addEventListener('click', function (event) {
  const button = event.target.closest('.aht-primary-button');

  if (!button) return;

  const target = document.querySelector('.picky-byob-bundle');

  if (target) {
    event.preventDefault();

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});